import './CalculatorCellsStyle.less';

import { Icon, Tooltip } from '@opendoor/bricks';
import classNames from 'classnames';
import { compact } from 'lodash';
import React from 'react';

import getCurrencyString from '../../helpers/getCurrencyString';

export interface IFieldLabelProps {
  label?: React.ReactNode;
  tooltip?: React.ReactNode;
}

export interface ISubfieldLabelProps {
  label?: React.ReactNode;
  onClick: () => void;
  showSubFields: boolean;
}

export interface ITextColumnProps {
  bold?: boolean;
  children: React.ReactNode;
  primary?: boolean;
}

export interface IHeaderColumnProps {
  headline?: number;
  primary?: boolean;
  subtitle?: string;
  title: string;
}

export interface IPerkListColumnProps {
  perks: string[];
  isPerk: boolean;
}

export const FieldLabel: React.SFC<IFieldLabelProps> = ({ label, tooltip }) => (
  <div>
    <b>{label}</b>
    {tooltip ? <Tooltip delayHide={0}>{tooltip}</Tooltip> : null}
  </div>
);

export const SubfieldLabel: React.SFC<ISubfieldLabelProps> = ({
  label,
  onClick,
  showSubFields,
}) => (
  <div className="od-calculator-cell__subfield-label" onClick={onClick}>
    <div className="od-calculator-cell__subfield-label-toggle">
      {showSubFields ? <Icon name="ei-minus" /> : <Icon name="ei-plus" />}
    </div>
    <b>{label}</b>
  </div>
);

export const TextColumn: React.SFC<ITextColumnProps> = ({ bold, children, primary }) => {
  const textClasses = compact([bold && 'text-bold', primary && 'text-blue']);

  return <span className={textClasses.join(' ')}>{children}</span>;
};

export const HeaderColumn: React.SFC<IHeaderColumnProps> = ({
  headline,
  primary,
  subtitle,
  title,
}) => (
  <div className={primary ? 'od-calculator-cell__header' : 'od-calculator-cell__header-generic'}>
    {title && <b>{title}</b>}
    {headline && <h1 className="medium-headline">{getCurrencyString(headline)}</h1>}
    {subtitle && <span className="text-product-medium">{subtitle}</span>}
  </div>
);

export const PerkListColumn: React.SFC<IPerkListColumnProps> = ({ perks, isPerk }) => (
  <ul
    className={classNames('od-calculator-cell__perk-list', {
      'antiperk-list': !isPerk,
      'perk-list': isPerk,
    })}
  >
    {perks.map((perk, index) => (
      <li key={index}>{perk}</li>
    ))}
  </ul>
);
